import { render } from "./InscriptionsView.vue?vue&type=template&id=0d733d85"
import script from "./InscriptionsView.vue?vue&type=script&lang=js"
export * from "./InscriptionsView.vue?vue&type=script&lang=js"

import "./InscriptionsView.vue?vue&type=style&index=0&id=0d733d85&lang=scss"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__